import loadingPng from "../../assets/loading.png";
import s from "./LoadingSpinner.module.scss";

export default function LoadingSpinner() {
  return <div className={s.loadingIcon}><img src={loadingPng} alt="Fetching patient data"/></div>
};
